module.exports = __webpack_public_path__ + "img/home_hnews7_1.d65f859e.png";